function WithdrawIcon({ color }: { color?: string }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.05 16.2502H11.17C9.84001 16.2502 8.75 15.1302 8.75 13.7502C8.75 13.3402 9.09 13.0002 9.5 13.0002C9.91 13.0002 10.25 13.3402 10.25 13.7502C10.25 14.3002 10.66 14.7502 11.17 14.7502H13.05C13.44 14.7502 13.75 14.4002 13.75 13.9702C13.75 13.4302 13.6 13.3502 13.26 13.2302L10.25 12.1802C9.61 11.9502 8.75 11.4902 8.75 10.0202C8.75 8.77023 9.74001 7.74023 10.95 7.74023H12.83C14.16 7.74023 15.25 8.86023 15.25 10.2402C15.25 10.6502 14.91 10.9902 14.5 10.9902C14.09 10.9902 13.75 10.6502 13.75 10.2402C13.75 9.69023 13.34 9.24023 12.83 9.24023H10.95C10.56 9.24023 10.25 9.59023 10.25 10.0202C10.25 10.5602 10.4 10.6402 10.74 10.7602L13.75 11.8102C14.39 12.0402 15.25 12.5002 15.25 13.9702C15.25 15.2302 14.26 16.2502 13.05 16.2502Z"
        fill={color || "#1C274C"}
        className="fill"
      />
      <path
        d="M12 17.2505C11.59 17.2505 11.25 16.9105 11.25 16.5005V7.50049C11.25 7.09049 11.59 6.75049 12 6.75049C12.41 6.75049 12.75 7.09049 12.75 7.50049V16.5005C12.75 16.9105 12.41 17.2505 12 17.2505Z"
        fill={color || "#1C274C"}
        className="fill"
      />
      <path
        d="M12 22.7505C6.07 22.7505 1.25 17.9305 1.25 12.0005C1.25 6.07049 6.07 1.25049 12 1.25049C12.41 1.25049 12.75 1.59049 12.75 2.00049C12.75 2.41049 12.41 2.75049 12 2.75049C6.9 2.75049 2.75 6.90049 2.75 12.0005C2.75 17.1005 6.9 21.2505 12 21.2505C17.1 21.2505 21.25 17.1005 21.25 12.0005C21.25 11.5905 21.59 11.2505 22 11.2505C22.41 11.2505 22.75 11.5905 22.75 12.0005C22.75 17.9305 17.93 22.7505 12 22.7505Z"
        fill={color || "#1C274C"}
        className="fill"
      />
      <path
        d="M22 6.75049C21.59 6.75049 21.25 6.41049 21.25 6.00049V2.75049H18C17.59 2.75049 17.25 2.41049 17.25 2.00049C17.25 1.59049 17.59 1.25049 18 1.25049H22C22.41 1.25049 22.75 1.59049 22.75 2.00049V6.00049C22.75 6.41049 22.41 6.75049 22 6.75049Z"
        fill={color || "#1C274C"}
        className="fill"
      />
      <path
        d="M16.9999 7.75043C16.8099 7.75043 16.6199 7.68043 16.4699 7.53043C16.1799 7.24043 16.1799 6.76043 16.4699 6.47043L21.4699 1.47043C21.7599 1.18043 22.2399 1.18043 22.5299 1.47043C22.8199 1.76043 22.8199 2.24043 22.5299 2.53043L17.5299 7.53043C17.3799 7.68043 17.1899 7.75043 16.9999 7.75043Z"
        fill={color || "#1C274C"}
        className="fill"
      />
    </svg>
  );
}

export default WithdrawIcon;
